import { render, staticRenderFns } from "./AdminAutoUpdatePrice.vue?vue&type=template&id=02ce67b0&scoped=true&"
import script from "./AdminAutoUpdatePrice.vue?vue&type=script&lang=js&"
export * from "./AdminAutoUpdatePrice.vue?vue&type=script&lang=js&"
import style0 from "./AdminAutoUpdatePrice.vue?vue&type=style&index=0&id=02ce67b0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02ce67b0",
  null
  
)

export default component.exports